import { LocalDate, LocalTime } from "@js-joda/core";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

export const localTimeToDayJs = (time: LocalTime): Dayjs => dayjs(`1970-01-01T${time.toString()}`);
export const dayJsToLocalTime = (time: Dayjs): LocalTime =>
    LocalTime.of(time.hour(), time.minute(), time.second());

export const localDateToDayjs = (date: LocalDate | string | Record<string, unknown>): Dayjs => {
    if (typeof date === "string") {
        return dayjs(date);
    }
    if (date instanceof LocalDate) {
        return dayjs(date.toString());
    }
    // Handle plain objects that might have date properties
    if (typeof date === "object" && date !== null) {
        // Try to extract date string from common formats
        if ("toString" in date && typeof date.toString === "function") {
            return dayjs(date.toString());
        }
    }
    return dayjs(date as unknown as string);
};

export const dayjsToLocalDate = (date: Dayjs): LocalDate =>
    LocalDate.of(date.year(), date.month() + 1, date.date());

export const dateToDayjs = (date: Date): Dayjs => dayjs(date.toString());

export const dayjsToDate = (date: Dayjs): Date => date.toDate();
